import { render, staticRenderFns } from "./ListOrganizations.vue?vue&type=template&id=f8205b8c&"
import script from "./ListOrganizations.vue?vue&type=script&lang=js&"
export * from "./ListOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports